var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"families-description",class:{ 'families-description--compact': _vm.compact}},[_c('div',{staticClass:"family"},[_vm._v(_vm._s(_vm.data.family.name))]),_c('div',{staticClass:"subfamily"},[_vm._v(_vm._s(_vm.data.subfamily.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }